import * as types from '../actions/actionTypes';

const initialState = {
  layoutHistory: [],
};

export default function(state = initialState, action) {

  switch(action.type) {

    case types.ADD_LAYOUT_HISTORY: {
      const lastState = state.layoutHistory[state.layoutHistory.length - 1];
      if (lastState) {
        if (JSON.stringify(lastState) !== JSON.stringify(action.payload.layoutState)) {
          state.layoutHistory.push(action.payload.layoutState)
        }
      } else {
        state.layoutHistory.push(action.payload.layoutState)
      }
      return Object.assign({}, state, {
        layoutHistory: state.layoutHistory
      })
    }
    case types.SET_LAYOUT_HISTORY:
      return Object.assign({}, state, {
        ...action.payload
      })
  }

  return state;

}
